import api from 'app/api';
import store from 'app/store';

export const getVenueList = async (callback) => {
  const successCallback = ({ data }) => {
    const venueList = (data || []).map((item) => ({ ...item, id: item?._id, label: item?.venueName }));
    store.dispatch({ type: 'ADMIN_VENUE_LIST:VENUE_LIST:SET', data: venueList });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/venueList`,
    {
      id: 'list-venues',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        page_no: 0,
      },
    },
  );
};

export const createVenue = async (payload, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.post(
    `/venues`,
    payload,
    {
      id: 'create-venue',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const updateVenue = async (id, payload, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.put(
    `/venues/${id}`,
    payload,
    {
      id: 'update-venue',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const deleteVenue = async (id, callback = () => null) => {
  await api.delete(
    `/venues/${id}`,
    {
      id: 'delete',
      success: {
        callback: callback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const getCitiesList = async (callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'ADMIN_VENUE_LIST:CITY_LIST:SET', data: (data || []).map((item) => ({ ...item, id: item?._id, label: item?.cityName })) });

    if (callback) callback(data);
  };

  await api.get(
    `/venues/city`,
    {
      id: 'list-cities',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isAdmin: true,
      },
    },
  );
};
